import Image from "next/image";
import Link from "next/link";
import { isMobile } from "react-device-detect";
import React, { FC } from "react";
import { useRouter } from "next/router";

interface NavBarProps {}

const NavBar: FC<NavBarProps> = () => {
  const router = useRouter();
  return (
    <div className="mx-4 sm:mx-8 xl:mx-20 2xl:mx-48">
      <div className="w-full py-4 sm:py-8  flex items-center justify-between ">
        <div className="w-full lg:w-56 flex justify-between items-center">
          <div className="flex items-center">
            <div className="relative overflow-y-hidden h-8 w-36">
              <Image src="/icons/logo-text.svg" alt="" layout="fill" />
            </div>
          </div>
          <Link href={"/auth/login"}>
            <a className="bg-green-light flex justify-center items-center font-semibold h-10 w-24  custom-border-radius outline-none ml-4 lg:hidden">
              Login
            </a>
          </Link>
        </div>
        <div className="hidden lg:flex items-center">
          {/* <Link href="/">
            <a className="mr-16 custom-text-green">FAQs</a>
          </Link> */}
          <button
            onClick={() => router.push("/auth/login")}
            className="bg-green-light w-36 text-center py-3 rounded-xl mr-4"
          >
            Login
          </button>
          <button
            onClick={() => router.push("/auth/get-started")}
            className="bg-green-dark w-36 text-center py-3 rounded-xl"
          >
            Get Started
          </button>
        </div>
      </div>
    </div>
  );
};

export default NavBar;
